import React, { Component } from "react";
import { reduxForm, Field, reset, formValueSelector } from "redux-form";
import { required, renderField } from "../../support/forms";
import { renderSelectList, renderSelectIdNameField } from "../../support/forms";
import { FinalFormCheckbox, FinalFormTextField } from "../../common/formWrappers";
import { unassignDirectorAdvisor, setDirector, getSchoolsForAdvisorId, getInstitionsForAdvisorId, getAdvisorBasics, getPotentialAdvisorSubordinates, assignAdvisorSchool, unassignAdvisorSchool, assignDirectorAdvisor, setGap, setHonorific, setAccelerate, assignAdvisorInstitution, unassignAdvisorInstitution } from "./apis";
import Multiselect from 'multiselect-react-dropdown';
import Checkbox from "@material-ui/core/Checkbox";
import { Grid, } from '@material-ui/core';
import { FormControlLabel } from '@mui/material';
import Link from "@material-ui/core/Link";
import AdvisorContext from "../context/context";
import Reporting from "../../common/reporting";

import "./Edit.css";


const preSelectedReportFields = ["userProfile.firstName", "userProfile.lastName", "userProfile.address1", "userProfile.address2", "userProfile.city", "userProfile.state", "userProfile.zipCode", "userProfile.email", "userProfile.mobilePhone"];
const skippedFields = ["studentProfile.collegeId", "studentProfile.userProfileId", "userProfile.scholarshipCrusaders", "userProfile.emergencyContacts", "userProfile.isDeleted", "userProfile.deleterUserId", "userProfile.deletionTime", "userProfile.lastModificationTime", "userProfile.lastModifierUserId", "userProfile.creationTime", "userProfile.creatorUserId", "userProfile.domainEvents", "userProfile.id", "userProfile.userId", "userProfile.user", "userProfile.userType", "userProfile.cityId", "userProfile.bestTimeCallStart", "userProfile.primaryPhone", "userProfile.bestTimeCallEnd", "userProfile.highestLevelEducation", "userProfile.highestLevelEducationGrade", "userProfile.highestLevelEducationInUS", "userProfile.secondarySendCopy", "userProfile.schoolId", "userProfile.grade", "studentProfile.selectedInstitutionId", "studentProfile.selectedInstitutionModifiedDate", "studentProfile.otherInstitution", "studentProfile.isDeleted", "studentProfile.deleterUserId", "studentProfile.deletionTime", "studentProfile.lastModificationTime", "studentProfile.lastModifierUserId", "studentProfile.creationTime", "studentProfile.creatorUserId", "studentProfile.domainEvents", "studentProfile.id", "school.districtId", "school.userSettingSchools", "school.isActive", "school.domainEvents", "school.id", "advisor.userId", "advisor.user", "advisor.userType", "advisor.middleName", "advisor.address1", "advisor.address2", "advisor.city", "advisor.cityId", "advisor.state", "advisor.zipCode", "advisor.homePhone", "advisor.bestTimeCallStart", "advisor.primaryPhone", "advisor.primaryLocale", "advisor.highestLevelEducation", "advisor.highestLevelEducationGrade", "advisor.highestLevelEducationInUS", "advisor.secondarySendCopy", "advisor.dateOfBirth", "advisor.schoolId", "advisor.citizenshipType", "advisor.hispanic", "advisor.race", "advisor.otherRace", "advisor.freeOrReducedLunch", "advisor.firstGeneration", "advisor.grade", "advisor.allergies", "advisor.medications", "advisor.medicalConditions", "advisor.dietaryRestrictions", "advisor.specialAccommodations", "advisor.scholarshipCrusaders", "advisor.emergencyContacts", "advisor.lastModificationTime", "advisor.lastModifierUserId", "family.primaryParent.userId", "family.primaryParent.user", "family.primaryParent.userType", "family.primaryParent.cityId", "family.primaryParent.secondarySendCopy", "family.primaryParent.scholarshipCrusaders", "family.primaryParent.emergencyContacts", "family.primaryParent.isDeleted", "family.primaryParent.deleterUserId", "family.primaryParent.deletionTime", "family.primaryParent.lastModificationTime", "family.primaryParent.lastModifierUserId", "family.primaryParent.creationTime", "family.primaryParent.creatorUserId", "family.primaryParent.domainEvents", "family.primaryParent.id", "family.secondaryParent.userId", "family.secondaryParent.user", "family.secondaryParent.userType", "family.secondaryParent.cityId", "family.secondaryParent.secondarySendCopy", "family.secondaryParent.freeOrReducedLunch", "family.secondaryParent.firstGeneration", "family.secondaryParent.grade", "family.secondaryParent.scholarshipCrusaders", "family.secondaryParent.emergencyContacts", "family.secondaryParent.isDeleted", "family.secondaryParent.deleterUserId", "family.secondaryParent.deletionTime", "family.secondaryParent.lastModificationTime", "family.secondaryParent.lastModifierUserId", "family.secondaryParent.creationTime", "family.secondaryParent.creatorUserId", "family.secondaryParent.domainEvents", "family.secondaryParent.id", "family.studentUserProfileId"]

class AdvisorEdit extends Component {
    
    static contextType = AdvisorContext;
    state = {
        
        schools: [],
        institutions: [],
        caseload: 0,
        cases: [],
        advisorInfo: [],
        totalLength: 0,
        loaded: false

    };

    componentDidMount = async () => {


        const advsch = await getSchoolsForAdvisorId(this.props.prof.userId);
        const advInst = await getInstitionsForAdvisorId(this.props.prof.userId);
        let schools = [];
        let institutions = [];
       

       let mCases = advsch.data.result.filter(cs => cs.isAssigned == true);
 
        let mInst = advInst.data.result.filter(cs => cs.isAssigned == true);
        
        if (mCases != null) {
            mCases.forEach((schl) => {
                const sch = this.context.schoolList.filter(sc => sc.id == schl.id);

                if (schools.indexOf(sch[0]) == -1) {
                    schools.push(sch[0]);
                }

                
            });
           
        }

        if (mInst != null) {
            mInst.forEach((inst) => {
                const sch = this.context.institutionList.filter(sc => sc.id == inst.id);

                if (institutions.indexOf(sch[0]) == -1) {
                    institutions.push(sch[0]);
                }


            });

        }
        
        const advInfo = await getAdvisorBasics(this.props.prof.userId);
        const cl = this.context.myCases.filter(myCase =>
            myCase.allAdvisors && // Check that allAdvisors exists
            Array.isArray(myCase.allAdvisors) && // Ensure allAdvisors is an array
            myCase.allAdvisors.some(advisor => advisor.userId == this.props.prof.userId) // Apply the filter
        );
       

        

        this.setState({ schools: schools, caseload: cl.length, cases: cl, advisorInfo: advInfo.data.result, institutions: institutions, totalLength: this.context.myCases.length, loaded: true  });
        
    }

    componentDidUpdate(prevProps, prevState) {
        // Only run if the context has changed
        //console.log(this);
        if (!this.state.loaded) {
            const ld = this.context.loaded;
            if (ld == true && this.context.myCases.length != this.state.totalLength) {
                const cl = this.context.myCases.filter(myCase =>
                    myCase.allAdvisors &&
                    Array.isArray(myCase.allAdvisors) &&
                    myCase.allAdvisors.some(advisor => advisor.userId == this.props.prof.userId));
                this.setState({ caseload: cl.length, cases: cl, totalLength: this.context.myCases.length, loaded: true });
            } 
            
        }

        
        }

       

    

    onSchoolSelect = async (selectedList, selectedItem) => {
        
        const data = { schoolId: selectedItem.id, userProfileId: this.props.prof.id };
        await assignAdvisorSchool(data);
        this.props.setEdited(true);
        
    }
    onSchoolRemove = async (selectedList, removedItem) => {
       

        const data = { schoolId: removedItem.id, userProfileId: this.props.prof.id };
        await unassignAdvisorSchool(data);
        this.props.setEdited(true);
        
        

    }

    onInstSelect = async (selectedList, selectedItem) => {

        const data = { institutionId: selectedItem.id, userProfileId: this.props.prof.id };
        await assignAdvisorInstitution(data);
        this.props.setEdited(true);
        
    }
    onInstRemove = async (selectedList, removedItem) => {


        const data = { institutionId: removedItem.id, userProfileId: this.props.prof.id };
        await unassignAdvisorInstitution(data);
        this.props.setEdited(true);
        


    }

    refreshCases = async () => {
        this.context.setLoaded(false);
       
        this.setState({ loaded: false });

        await this.context.refreshCases();
    }
    
    render() {

        
        return (
            <div>
                <Grid container spacing={2}>

                    <Grid item xs={6} className="advisorProfileNameColumn">
                    {this.props.prof.firstName} {this.props.prof.lastName}
                        <br />
                        <br />
                        <Link


                            href={"mailto:" + this.props.prof.email}
                        >
                            {this.props.prof.email}
                        </Link>
                        <br />

                        {this.props.prof.mobilePhone}
                    </Grid>
                    <Grid item xs={6}>
                        <span>Schools</span>
                        <Multiselect
                            options={this.context.schoolList} // Options to display in the dropdown
                            selectedValues={this.state.schools} // Preselected value to persist in dropdown
                            onSelect={this.onSchoolSelect} // Function will trigger on select event
                            onRemove={this.onSchoolRemove} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            className="AdvisorSchoolSelector"
                            disable={this.props.readonly }

                        />

                    </Grid>
                    <Grid item xs={6} className="advisorProfileNameColumn">
                       
                    </Grid>
                    <Grid item xs={6}>
                    

                            <span>Institutions</span>
                            <Multiselect
                                options={this.context.institutionList} // Options to display in the dropdown
                                selectedValues={this.state.institutions} // Preselected value to persist in dropdown
                                onSelect={this.onInstSelect} // Function will trigger on select event
                                onRemove={this.onInstRemove} // Function will trigger on remove event
                                displayValue="name" // Property name to display in the dropdown options
                                className="AdvisorSchoolSelector"
                                disable={this.props.readonly} />

                        <br />
                    </Grid>
                   
                    
                </Grid>


                
                <br />
                <br />
                <Link

                    className={"headerlink"}
                    onClick={()=> this.props.onClose()}
                >
                    &nbsp; Close &nbsp;
                </Link>
            </div>
              );
    }
}

export default AdvisorEdit;